import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormCreateCompany from '../../../components/Forms/FormCreateCompany/FormCreateCompany';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  CompanyResponse,
  IErrorsCompanies,
} from '../../../models/CompaniesModel';
import { CustomToggle } from '../../../components/Forms/FormInput/CustomToggle/CustomToggle';
import Button from '../../../components/Button/Button';
import { useEndpoints } from '../../../hooks/useEndpoints';
import Modal from '../../../components/Modal/Modal';
import { useToastAlert } from '../../../components/ToastAlert/ToastAlert';
import { DURATION_TOAST } from '../../../utils/costants';
import { RoutesRouter } from '../../../models/Routes';
import Skeleton from 'react-loading-skeleton';

export const CreateCompany = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const {
    getCompanyById,
    patchCompany,
    putCompany,
    createCompany,
    resetPassword,
  } = useEndpoints();
  const { showToast } = useToastAlert();
  const navigate = useNavigate();
  const [isOpenModalPassword, setOpenModalPassword] = useState<boolean>(false);
  const [isOpenModalEnable, setOpenModalEnable] = useState<boolean>(false);
  const [isOpenModalLibraryEnabled, setOpenModalLibraryEnabled] =
    useState<boolean>(false);
  const [isLoading, setIsloading] = useState(false);
  const [company, setCompany] = useState<CompanyResponse>();
  const [isEnable, setEnable] = useState<boolean>(false);
  const [isLibraryEnabled, setLibraryEnabled] = useState<boolean>(false);

  const { pathname } = useLocation();
  useEffect(() => {
    if (id) {
      setIsloading(true);
      getCompanyById(id).then((resp) => {
        setCompany(resp);
        setEnable(resp.enabled);
        setLibraryEnabled(resp.libraryEnabled);
        setIsloading(false);
      });
    }
  }, [id, getCompanyById, pathname, company?.name]);

  const onSubmitForm = async (data: CompanyResponse) => {
    if (id) {
      const response = await putCompany(id, data);
      if (response.status === 200) {
        navigate(RoutesRouter.companies);
        showToast({
          message: `${t('home.companies.toast.success.edit')}`,
          type: 'success',
          duration: DURATION_TOAST,
        });
      }
      if (response.status === 400) {
        const { errors } = await response.json();
        errors.map(({ value, msg, param }: IErrorsCompanies) =>
          showToast({
            message: `${msg} ${param}`,
            subMessage: value,
            type: 'error',
          })
        );
      }
      if (response.status === 500) {
        showToast({
          message: `${t('home.companies.toast.error.generic')}`,
          type: 'error',
        });
      }
    } else {
      const response = await createCompany(data);
      if (response.status === 201) {
        navigate(RoutesRouter.companies);
        showToast({
          message: `${t('home.companies.toast.success.create')}`,
          type: 'success',
          duration: DURATION_TOAST,
        });
      }
      if (response.status === 400) {
        const { errors } = await response.json();
        errors.map(({ value, msg, param }: IErrorsCompanies) =>
          showToast({
            message: `${msg} ${param}`,
            subMessage: value,
            type: 'error',
          })
        );
      }
      if (response.status === 500) {
        showToast({
          message: `${t('home.companies.toast.error.generic')}`,
          type: 'error',
        });
      }
    }
  };

  return (
    <div className="container-custom custom-form-container">
      <div className="container__home">
        <div className="container__top">
          <div className="left">
            <h1 className="title-page capitalize-first-letter">
              {isLoading ? (
                <Skeleton />
              ) : (
                company?.name || t('createAgency.title.edit')
              )}
            </h1>
            <p className="page-description capitalize-first-letter mt-1">
              {company?.name
                ? t('createAgency.description.edit')
                : t('createAgency.description.create')}
            </p>
          </div>
          {isLoading ? (
            <Skeleton height={42} width={400} count={1} />
          ) : (
            company && (
              <div className="right">
                <CustomToggle
                  onChange={() => setOpenModalLibraryEnabled(true)}
                  value={isLibraryEnabled}
                  label={
                    isLibraryEnabled
                      ? t('createAgency.description.toggle.libraryEnabled')
                      : t('createAgency.description.toggle.libraryDisabled')
                  }
                />
                <CustomToggle
                  onChange={() => setOpenModalEnable(true)}
                  value={isEnable}
                  label={
                    isEnable
                      ? t('createAgency.description.toggle.enabled')
                      : t('createAgency.description.toggle.disabled')
                  }
                />
                <Button
                  onClick={() => {
                    setOpenModalPassword(true);
                  }}
                  outline
                >
                  {t('createAgency.description.labelButton')}
                </Button>
              </div>
            )
          )}
        </div>
        <FormCreateCompany
          isLoading={isLoading}
          companyData={company}
          onSumbitForm={onSubmitForm}
        />
      </div>
      {id && company && isOpenModalPassword && (
        <Modal
          close={() => setOpenModalPassword(false)}
          open={isOpenModalPassword}
          children={
            <div>
              <div className="content">
                <h2>{t('home.companies.modal.password.title')}</h2>
              </div>
              <div className="footer">
                <Button onClick={() => setOpenModalPassword(false)} outline>
                  {t('home.companies.modal.cancel')}
                </Button>
                <Button
                  onClick={async () => {
                    const resp = await resetPassword({
                      email: company.hrEmail,
                    });
                    if (resp.status === 200) {
                      showToast({
                        message: `${t(
                          'home.companies.toast.success.password'
                        )}`,
                        type: 'success',
                        duration: DURATION_TOAST,
                      });
                      /*  navigator.clipboard
                        .writeText("melo")
                        .then(() => {
                          showToast([
                            {
                              message: `${t(
                                "home.companies.toast.success.password"
                              )}`,
                              type: "success",
                              duration: DURATION_TOAST,
                            },
                            {
                              message: `${t(
                                "home.companies.toast.success.copyPassword"
                              )}`,
                              type: "success",
                              duration: DURATION_TOAST,
                            },
                          ]);
                        })
                        .catch((error) => {
                          console.error(error);
                        }); */
                      setOpenModalPassword(false);
                    }
                    if (resp.status === 400) {
                      const { errors } = await resp.json();
                      errors.map(({ value, msg, param }: IErrorsCompanies) =>
                        showToast({
                          message: `${msg} ${param}`,
                          subMessage: value,
                          type: 'error',
                        })
                      );
                    }
                    if (resp.status === 500) {
                      showToast({
                        message: `${t('home.companies.toast.error.generic')}`,
                        type: 'error',
                      });
                    }
                  }}
                >
                  {t('home.companies.modal.confirm')}
                </Button>
              </div>
            </div>
          }
        />
      )}
      {id && company && isOpenModalEnable && (
        <Modal
          close={() => setOpenModalEnable(false)}
          open={isOpenModalEnable}
          children={
            <div>
              <div className="content form-create-questions">
                <h2 className="title-modal">
                  {isEnable
                    ? `${t('home.companies.modal.enable.title.enabled')} ${
                        company.name
                      }?`
                    : `${t('home.companies.modal.enable.title.disabled')} ${
                        company.name
                      }?`}
                </h2>
                <p>
                  {isEnable
                    ? t('home.companies.modal.enable.description.enabled')
                    : t('home.companies.modal.enable.description.disabled')}
                </p>
              </div>
              <div className="footer">
                <Button onClick={() => setOpenModalEnable(false)} outline>
                  Annulla
                </Button>
                <Button
                  onClick={() =>
                    id &&
                    patchCompany(id, { enabled: !isEnable }).then((resp) => {
                      if (resp.status === 200) {
                        setOpenModalEnable(false);
                        showToast({
                          message: `${
                            isEnable
                              ? t('home.companies.toast.success.disabled')
                              : t('home.companies.toast.success.enabled')
                          }`,
                          type: 'success',
                          duration: DURATION_TOAST,
                        });
                        setEnable((oldValue) => !oldValue);
                      }
                      if (resp.status === 500) {
                        showToast({
                          message: `${t('home.companies.toast.error.generic')}`,
                          type: 'error',
                        });
                      }
                    })
                  }
                >
                  Conferma
                </Button>
              </div>
            </div>
          }
        />
      )}
      {id && company && isOpenModalLibraryEnabled && (
        <Modal
          close={() => setOpenModalLibraryEnabled(false)}
          open={isOpenModalLibraryEnabled}
          children={
            <div>
              <div className="content form-create-questions">
                <h2 className="title-modal">
                  {isLibraryEnabled
                    ? `${t(
                        'home.companies.modal.enable.title.libraryEnabled'
                      )} ${company.name}?`
                    : `${t(
                        'home.companies.modal.enable.title.libraryDisabled'
                      )} ${company.name}?`}
                </h2>
                <p>
                  {isLibraryEnabled
                    ? t(
                        'home.companies.modal.enable.description.libraryEnabled'
                      )
                    : t(
                        'home.companies.modal.enable.description.libraryDisabled'
                      )}
                </p>
              </div>
              <div className="footer">
                <Button
                  onClick={() => setOpenModalLibraryEnabled(false)}
                  outline
                >
                  Annulla
                </Button>
                <Button
                  onClick={() =>
                    id &&
                    patchCompany(id, {
                      libraryEnabled: !isLibraryEnabled,
                    }).then((resp) => {
                      if (resp.status === 200) {
                        setOpenModalLibraryEnabled(false);
                        showToast({
                          message: `${
                            isLibraryEnabled
                              ? t('home.companies.toast.success.libraryDisabled')
                              : t('home.companies.toast.success.libraryEnabled')
                          }`,
                          type: 'success',
                          duration: DURATION_TOAST,
                        });
                        setLibraryEnabled((oldValue) => !oldValue);
                      }
                      if (resp.status === 500) {
                        showToast({
                          message: `${t('home.companies.toast.error.generic')}`,
                          type: 'error',
                        });
                      }
                    })
                  }
                >
                  Conferma
                </Button>
              </div>
            </div>
          }
        />
      )}
    </div>
  );
};
